import { render } from "./BaseModal.vue?vue&type=template&id=4238ecbe&scoped=true&ts=true"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"

import "./BaseModal.vue?vue&type=style&index=0&id=4238ecbe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4238ecbe"]])

export default __exports__